"use strict";

var end = {};

module.exports.ForschungsprojektResource = {
  organisationseinheit: end,
  weitereOrganisationseinheiten: end,
  antragsteller: end,
  foerderung: end,
  // mittelgeber are already included in foerderung with leuris_refobbed
  // {
  //   mittelgeber: end
  // },
  mitarbeiter: end,
  // deprecated
  // projektLeiter: end,
  projektleiter: end,
  publikation: end,
  sdg: end,
  sprecherhochschule: end
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/resource/forschungsprojekt.js
// module id = 6tpL
// module chunks = 0